import React from 'react';
import classnames from 'classnames';
import styled from '@benzinga/themetron';
import { DetailedQuote, isQuoteTradeTimesEquals } from '@benzinga/quotes-manager';
import { formatRound, formatRoundFixed } from '@benzinga/utils';
import { Up } from '@benzinga/themed-icons';

export const UpArrow = <Up className="fill-current mr-1" height="0.8em" viewBox="0 0 24 24" width="0.8em" />;
export const DownArrow = (
  <Up className="rotate-180 fill-current mr-1" height="0.8em" viewBox="0 0 24 24" width="0.8em" />
);

// TODO: Combine identical props to a generic interface
// TODO: Reduce Every component size
interface Props {
  quote: DetailedQuote;
  type?: string;
}

const PRE_MARKET = 'PRE_MARKET';
const AFTER_MARKET = 'AFTER_MARKET';

export const QuoteValue = React.memo(({ quote, type }: Props) => {
  if (!quote) return null;
  if (quote.lastTradePrice === undefined) return null;

  let color;
  let ethColor;
  let ethChange: number | undefined;
  let ethChangePercent: number | undefined;
  let arrow: JSX.Element | null = null;

  if (quote.change === 0) {
    color = 'text-grey-darker';
  } else if (quote.change < 0) {
    color = 'text-red-dark';
    arrow = DownArrow;
  } else {
    color = 'text-green-dark';
    arrow = UpArrow;
  }

  if ((type === PRE_MARKET || type === AFTER_MARKET) && quote.ethPrice !== undefined) {
    ethChange = quote.ethPrice - quote.lastTradePrice;
    ethChangePercent = (ethChange / quote.lastTradePrice) * 100;
    if (ethChange !== 0) {
      ethColor = ethChange > 0 ? 'text-green-dark' : 'text-red-dark';
    } else {
      ethColor = 'text-grey-darker';
    }
  }

  return (
    <Container className="quote-value-container">
      <div className="quote-numbers">
        <span className="quote-price">{formatRoundFixed(quote.lastTradePrice, 2)}</span>
        <div className="quote-change">
          {quote.change !== undefined && (
            <div className={classnames('quote-change', color)}>
              {arrow}
              {quote.change > 0 ? '+' : ''}
              {formatRoundFixed(quote.change, 2)}
            </div>
          )}
          <span className={classnames('quote-change-percent', color)}>[{formatRound(quote.changePercent)}%]</span>
        </div>
      </div>
      {(type === PRE_MARKET || type === AFTER_MARKET) && quote.ethPrice !== undefined && (
        <div>
          <span className="quote-price">{formatRoundFixed(quote.ethPrice, 2)}</span>{' '}
          <span className={classnames(ethColor)} />
          <span className={classnames('quote-change', ethColor)}>
            {Number(ethChange) > 0 ? '+' : ''}
            {formatRoundFixed(Number(ethChange), 2)}
          </span>{' '}
          <span className={classnames('quote-change-percent', ethColor)}>
            [{formatRound(Number(ethChangePercent))}%]
          </span>
        </div>
      )}
    </Container>
  );
}, isQuoteTradeTimesEquals);

export default QuoteValue;

const Container = styled.div`
  &.quote-value-container {
    .quote-price {
      font-size: ${({ theme }) => theme.fontSize['3xl']};
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
      margin-right: 10px;
    }

    .quote-change {
      font-size: ${({ theme }) => theme.fontSize['2xl']};
      white-space: nowrap;
      align-items: center;
      display: inline-flex;
      margin-right: 0.5rem;
    }

    .quote-change-percent {
      font-size: ${({ theme }) => theme.fontSize['2xl']};
    }
  }
`;
